import { createSelector } from '@reduxjs/toolkit';
import { ELevelResult } from 'Shared/types';
import { AssociationsService } from 'PhenotypeView/services';
import { getPhenotype, getTraitsType } from '../../common';
import { getState } from '../../rootState';
export const getLevelResultState = createSelector(getState, (state) => state[ELevelResult.Phenotype]);
export const getAssociations = createSelector(getLevelResultState, ({ associations }) => associations);
export const getTableSettings = createSelector(getLevelResultState, ({ tableSettings }) => tableSettings);
export const getFilteredAssociationsIds = createSelector(getLevelResultState, ({ filteredAssociationsIds }) => filteredAssociationsIds);
export const getIsFiltering = createSelector(getLevelResultState, ({ isFiltering }) => isFiltering);
export const getFilters = createSelector(getLevelResultState, ({ filters }) => filters);
export const getTableData = createSelector(getAssociations, getFilteredAssociationsIds, ({ collection }, filteredAssociationsIds) => AssociationsService.getTableData(collection, filteredAssociationsIds));
export const getAllTableData = createSelector(getAssociations, ({ collection, order }) => AssociationsService.getTableData(collection, order));
export const getPhenotypes = createSelector(getLevelResultState, ({ phenotypes }) => phenotypes);
export const getCategories = createSelector(getLevelResultState, ({ categories }) => categories);
export const getPlotData = createSelector(getFilters, getTableData, getTraitsType, (filters, associations, traitsType) => AssociationsService.getPlotDataPLR(filters.categories, associations, traitsType));
export const getAllPlotData = createSelector(getFilters, getAllTableData, getTraitsType, (filters, associations, traitsType) => AssociationsService.getPlotDataPLR(filters.categories, associations, traitsType));
export const getAncestries = createSelector(getLevelResultState, ({ ancestries }) => ancestries);
export const getExportedData = createSelector(getTraitsType, getPhenotype, getTableData, getAllTableData, getPlotData, getAllPlotData, (traitsType, phenotype, tableData, allTableData, plotData, allPlotData) => ({
    traitsType,
    phenotype,
    tableData,
    allTableData,
    plotData,
    allPlotData,
}));
export const getFiltersData = createSelector(getFilters, getPhenotypes, getCategories, (filters, phenotypes, categories) => ({
    filters,
    phenotypes,
    categories,
}));
export default {
    getAncestries,
    getAssociations,
    getTableSettings,
    getFilteredAssociationsIds,
    getIsFiltering,
    getFilters,
    getTableData,
    getAllTableData,
    getPhenotypes,
    getCategories,
    getPlotData,
    getAllPlotData,
    getExportedData,
    getFiltersData,
};
